module.exports = __webpack_public_path__ + "img/green_059.aa520855.png";